/* global I18n */

import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import MemberTypePropertyFilterSelect from "./MemberTypePropertyFilterSelect";

const i18nOptions = {
  scope: "components.shift_report_form",
};

const ShiftReportForm = ({ memberTypeProperties, filtersParams = [] }) => {
  const [filters, setFilters] = useState(
    filtersParams.map((filterParams) => ({
      ...filterParams,
      key: uuidv4(),
    }))
  );

  const onMemberTypePropertyFilterChange = (key, changedAttributes) => {
    const { selectedId, filterValue } = changedAttributes;

    setFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.key === key) {
          return {
            ...filter,
            memberTypePropertyId: selectedId,
            value: filterValue,
          };
        }
        return filter;
      })
    );
  };

  const handleAddFilter = () => {
    setFilters((prevFilters) =>
      prevFilters.concat({
        key: uuidv4(),
        memberTypePropertyId: null,
        value: null,
      })
    );
  };

  const handleRemoveFilter = (key) => {
    setFilters((prevFilters) =>
      prevFilters.filter((filter) => filter.key !== key)
    );
  };

  const renderMemberTypePropertyFilters = () => {
    const filtersComponents = filters.map((filter) => (
      <MemberTypePropertyFilterSelect
        memberTypeProperties={memberTypeProperties}
        onChange={onMemberTypePropertyFilterChange}
        onRemove={handleRemoveFilter}
        attributes={filter}
        key={filter.key}
      />
    ));

    return filtersComponents.reduce(
      (accumulator, element) =>
        accumulator === null
          ? [element]
          : [
              ...accumulator,
              <p key={`and-${element.key}`}>{I18n.t("shared.and")}</p>,
              element,
            ],
      null
    );
  };

  return (
    <div className="form-group">
      <div>
        {renderMemberTypePropertyFilters()}
        <button
          className="btn btn-success"
          type="button"
          onClick={handleAddFilter}
        >
          {I18n.t("add_filter", i18nOptions)}
        </button>
      </div>
    </div>
  );
};

export default ShiftReportForm;
